import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { OkrObjectiveCommentCreate } from "server/models"
import { StateType } from "client/utils"
import {
    OkrObjectiveObjectProps,
    StoreType,

    LoadAllOkrObjectiveComments,
    LoadOkrObjectiveCommentById,
    SaveOkrObjectiveComment,
    DeleteOkrObjectiveComment,

    setOkrObjectiveCommentList,
} from "client/store"
import {
    Loader,
    Comments,
    EditCommentType,
    SaveCommentType,
    DeleteCommentType,
} from "client/components"

import { ObjectiveCommentListWrapper } from "client/pages/okr/styled"

const ObjectiveComments = ({
    objective,
}: OkrObjectiveObjectProps) => {
    const commentList = useSelector((state: StoreType) => state.okrObjectiveComment.commentList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!objective) return

        setLoadState(PENDING)
        LoadAllOkrObjectiveComments(objective.id).then((comments) => {
            setLoadState(IDLE)
            dispatch(setOkrObjectiveCommentList(objective.id, comments))
        })
    }, [objective])

    const onEdit: EditCommentType = (activeComment, editCallback) => {
        LoadOkrObjectiveCommentById(activeComment.id)
        .then((res) => editCallback(res))
    }

    const onSave: SaveCommentType = (comment, attachments, saveCallback) => {
        const newCommentData: OkrObjectiveCommentCreate = {
            objectiveId: objective.id,
            comment: comment.comment,
            author: comment.author,
        }

        SaveOkrObjectiveComment(
            comment.id,
            newCommentData,
            attachments,
            lang,
        ).then((res) => {
            if (!res.validation) {
                LoadAllOkrObjectiveComments(objective.id).then((comments) => {
                    dispatch(setOkrObjectiveCommentList(objective.id, comments))
                    saveCallback(res.validation)
                })
            } else {
                saveCallback(res.validation)
            }
        })
    }

    const onDelete: DeleteCommentType = (activeComment, deleteCallback) => {
        DeleteOkrObjectiveComment(activeComment.id, objective.id).then((removedRows) => {
            if (removedRows === 1) {
                dispatch(setOkrObjectiveCommentList(objective.id, commentList[objective.id].filter((row) => row.id !== activeComment.id)))
                deleteCallback()
            }
        })
    }

    return (
        <ObjectiveCommentListWrapper>
            {
                loadState === PENDING
                && <Loader />
            }

            <Comments
                comments={commentList[objective.id]}
                onEdit={onEdit}
                onSave={onSave}
                onDelete={onDelete}
            />
        </ObjectiveCommentListWrapper>
    )
}
export default ObjectiveComments
